import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskDelayRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskDelayRPage;
